<template>
  <div id="essay-image">
    <t-lined-textarea
      :styles="{ height: '1010px', width: '100%', minWidth: '30vw', resize: false }"
      v-model="essay.content"
    ></t-lined-textarea>
    <div id="capture" ref="essay" class="container">
      <div class="padding-buttons">
        <div class="columns">
          <div class="column is-6">
            <t-button
              :disabled="essay.content == ''"
              @click="sendEssay(true)"
            >
              Salvar como rascunho
            </t-button>
          </div>
          <div class="column is-6">
            <t-button
              :disabled="essay.content == ''"
              style="float:right"
              @click="sendEssay(false)"
              color="0f62ab"
            >
              Salvar e enviar para correção
            </t-button>
          </div>
        </div>
        <img :src="img">
      </div>
    </div>
  </div>
</template>
<script>
import TButton from '@/components/TButton.vue'
import TLinedTextarea from '@/components/TLinedTextarea.vue'
import EssayService from '@/services/essay/essay'
import Notification from '@/support/mixins/notifications.mixin'

export default {
  components: {
    TButton,
    TLinedTextarea
  },
  mixins: [Notification],
  data () {
    return {
      essay: {
        content: ''
      },
      img: null,
      themeId: this.$route.params.id,
      EssayService: new EssayService()
    }
  },
  methods: {
    async sendEssay (draft) {
      try {
        const print = await this.print()
        console.log(print)
        // const essay = { essayImage: print, themeId: this.themeId, draft }
        // const { data } = await this.EssayService.sendEssayImage(essay)
        // console.log(data)
        this.successMsg('Redação', 'Redação enviada ao corretor com sucesso', 'topCenter')
        this.essay.content = ''
      } catch (error) {
        this.errorMsg('Redação', error.message, 'topCenter')
      }
    },
    async print () {
      const essay = document.querySelector('#essay-image')
      console.log(essay)
      const options = {
        type: 'dataURL'
      }
      // eslint-disable-next-line no-undef
      // html2canvas(document.getElementById('essay-textarea')).then(canvas => {
      //   teste = canvas.toDataURL()
      // })

      const output = await this.$html2canvas(essay, options)
      this.img = output
      return this.dataURItoBlob(output)
    },
    dataURItoBlob (dataURI) {
      var byteString = atob(dataURI.split(',')[1])

      var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0]

      var ab = new ArrayBuffer(byteString.length)
      var ia = new Uint8Array(ab)
      for (var i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i)
      }

      return new Blob([ab], { type: mimeString })
    }
  }
}
</script>
<style scoped>
.padding-buttons {
  padding-left: 20%;
  padding-right: 20%;
}
@media screen and (min-width: 320px) and (max-width: 768px) {
 .padding-buttons {
  margin-bottom: 4rem;
}
}
</style>
